import type { App } from 'vue'
import { cookieBannerConfig } from '@/silktide/configs/cookieBanner.config'
import { formatMonthYearToBangkokEn } from '@/helpers/date'

const wnd: any = window

export default {
  install(app: App) {
    const date = new Date()
    const dateVersion = formatMonthYearToBangkokEn(date.toISOString()).replace(' ', '-')

    wnd.APP_CONFIG = {
        APP_VERSION: `V${process.env.VUE_APP_VERSION} ${dateVersion}`
    }

    wnd.addEventListener('load', () => {
      wnd.silktideCookieBannerManager?.updateCookieBannerConfig(
        cookieBannerConfig
      )
    })
  }
}
